import { defineMessages } from 'react-intl';
 
const Locale = defineMessages({
    partners_list_title: {
        id: 'productinsights.partners_list_title',
        defaultMessage: 'Partners List',
    },
    product_list_title: {
        id: 'productinsights.product_list_title',
        defaultMessage: 'Product Catalog',
    },
    cw_home: {
        id: 'productinsights.cw_home',
        defaultMessage: 'CW Home',
    },
    marketplace: {
        id: 'productinsights.marketplace',
        defaultMessage: 'Marketplace',
    },
    all: {
        id: 'productinsights.all',
        defaultMessage: 'All',
    },
    logout: {
        id: 'productinsights.logout',
        defaultMessage: 'Logout',
    },
    no_records: {
        id: 'productinsights.no_records',
        defaultMessage: 'No records found',
    },
    no_partners: {
        id: 'productinsights.no_partners',
        defaultMessage: 'No Partners Found',
    },
    details: {
        id: 'productinsights.details',
        defaultMessage: 'Details',
    },
    transactions: {
        id: 'productinsights.transactions',
        defaultMessage: 'Transactions',
    },
    products: {
        id: 'productinsights.products',
        defaultMessage: 'Products',
    },
    product_instances: {
        id: 'productinsights.product_instances',
        defaultMessage: 'Product Instances',
    },
    instances: {
        id: 'productinsights.instances',
        defaultMessage: 'Instances',
    },
    clients: {
        id: 'productinstances.clients',
        defaultMessage: 'Clients',
    },
    credit_cards: {
        id: 'productinsights.credit_cards',
        defaultMessage: 'Credit Cards',
    },
    support: {
        id: 'productinsights.support',
        defaultMessage: 'Support',
    },
    platform_product_entitlements: {
        id: 'productinsights.platform_product_entitlements',
        defaultMessage: 'Platform Product Entitlements',
    },
    users: {
        id: 'productinsights.users',
        defaultMessage: 'Users',
    },
    user_role_filter_by_role: {
        id: 'productinsights.user_role_filter_by_role',
        defaultMessage: 'Filter by role',
    },
    user_role_filter_active: {
        id: 'productinsights.user_role_filter_active',
        defaultMessage: 'Filter (active)',
    },
    user_role_filter_remove: {
        id: 'productinsights.user_role_filter_remove',
        defaultMessage: 'Remove filter',
    },
    user_role_filter_loading_users: {
        id: 'productinsights.user_role_filter_loading_users',
        defaultMessage: 'Loading users…',
    },
    user_role_filter_no_match: {
        id: 'productinsights.user_role_filter_no_match',
        defaultMessage: 'No users match the selected filters.',
    },
    user_role_filter_dialog_subtitle: {
        id: 'productinsights.user_role_filter_dialog_subtitle',
        defaultMessage: 'Users matching any selected role will be shown.',
    },
    user_role_filter_no_roles: {
        id: 'productinsights.user_role_filter_no_roles',
        defaultMessage: 'No identity roles available.',
    },
    user_role_filter_reset: {
        id: 'productinsights.user_role_filter_reset',
        defaultMessage: 'Reset',
    },
    user_role_filter_cancel: {
        id: 'productinsights.user_role_filter_cancel',
        defaultMessage: 'Cancel',
    },
    user_role_filter_apply: {
        id: 'productinsights.user_role_filter_apply',
        defaultMessage: 'Apply',
    },
    user_role_filter_catalog_load_error: {
        id: 'productinsights.user_role_filter_catalog_load_error',
        defaultMessage: 'Failed to load identity roles for filter.',
    },
    user_search_min_length: {
        id: 'productinsights.user_search_min_length',
        defaultMessage: 'Search should be at least 3 characters',
    },
    user_search_prompt: {
        id: 'productinsights.user_search_prompt',
        defaultMessage: 'Search for a user or partner to view results.',
    },
    user_search_looking_for: {
        id: 'productinsights.user_search_looking_for',
        defaultMessage: 'Search by:',
    },
    user_search_button: {
        id: 'productinsights.user_search_button',
        defaultMessage: 'Search',
    },
    user_search_clear: {
        id: 'productinsights.user_search_clear',
        defaultMessage: 'Clear search',
    },
    user_search_type_name: {
        id: 'productinsights.user_search_type_name',
        defaultMessage: 'Name',
    },
    user_search_type_email: {
        id: 'productinsights.user_search_type_email',
        defaultMessage: 'Email',
    },
    user_search_type_user_id: {
        id: 'productinsights.user_search_type_user_id',
        defaultMessage: 'User ID',
    },
    user_search_type_partner_id: {
        id: 'productinsights.user_search_type_partner_id',
        defaultMessage: 'Partner ID',
    },
    user_search_placeholder_name: {
        id: 'productinsights.user_search_placeholder_name',
        defaultMessage: 'Enter a name',
    },
    user_search_placeholder_email: {
        id: 'productinsights.user_search_placeholder_email',
        defaultMessage: 'Enter email or email prefix',
    },
    user_search_placeholder_user_id: {
        id: 'productinsights.user_search_placeholder_user_id',
        defaultMessage: 'Enter a user ID',
    },
    user_search_placeholder_partner_id: {
        id: 'productinsights.user_search_placeholder_partner_id',
        defaultMessage: 'Enter a partner ID',
    },
    user_search_required: {
        id: 'productinsights.user_search_required',
        defaultMessage: 'Enter a search value',
    },
    catalog_search_invalid_term: {
        id: 'productinsights.catalog_search_invalid_term',
        defaultMessage:
            'Search contains invalid characters. Remove characters such as &, /, or =.',
    },
    user_search_invalid_name: {
        id: 'productinsights.user_search_invalid_name',
        defaultMessage: 'Name contains invalid characters',
    },
    user_search_invalid_email: {
        id: 'productinsights.user_search_invalid_email',
        defaultMessage: 'Enter a valid email address',
    },
    user_search_invalid_user_id: {
        id: 'productinsights.user_search_invalid_user_id',
        defaultMessage: 'Enter a valid user ID',
    },
    user_search_invalid_partner_id: {
        id: 'productinsights.user_search_invalid_partner_id',
        defaultMessage: 'Enter a valid partner ID',
    },
    user_search_no_results: {
        id: 'productinsights.user_search_no_results',
        defaultMessage: 'No results found',
    },
    reassign_user: {
        id: 'productinsights.reassign_user',
        defaultMessage: 'Reassign User',
    },
    save: {
        id: 'productinsights.save',
        defaultMessage: 'Save',
    },
    delete_tenant: {
        id: 'productinsights.delete_tenant',
        defaultMessage: 'Delete Tenant',
    },
    delete: {
        id: 'productinsights.delete',
        defaultMessage: 'Delete',
    },
    reassign_product_instance: {
        id: 'productinsights.reassign_productinstance',
        defaultMessage: 'Reassign Product Instance',
    },
    required: {
        id: 'productinsights.required',
        defaultMessage: 'Required',
    },
    float: {
        id: 'productinsights.float',
        defaultMessage: 'Number field',
    },
    access_denied_subtitle: {
        id: 'productinsights.access_denied_subtitle',
        defaultMessage: "You don't have access to this page.",
    },
    access_denied_title: {
        id: 'productinsights.access_denied_title',
        defaultMessage: 'Access denied',
    },
    scheduled_transactions: {
        id: 'productinsights.scheduled_transactions',
        defaultMessage: 'Scheduled Transactions',
    },
    error_signing_in: {
        id: 'productinsights.error_signing_in',
        defaultMessage: 'Error signing in',
    },
    try_again: {
        id: 'productinsights.try_again',
        defaultMessage: 'Try Again',
    },
    cancel: {
        id: 'productinsights.cancel',
        defaultMessage: 'Cancel',
    },
    confirm_refund: {
        id: 'productinsights.confirm_refund',
        defaultMessage: 'Confirm Refund',
    },
    cant_find_page: {
        id: 'productinsights.cant_find_page',
        defaultMessage: "'Hmm... We can't seem to locate this page'",
    },
    check_url: {
        id: 'productinsights.check_url',
        defaultMessage: 'Please check the URL',
    },
    take_me_home: {
        id: 'productinsights.take_me_home',
        defaultMessage: 'Take me home',
    },
    partner_id_label: {
        id: 'productinsights.partner_id_label',
        defaultMessage: 'PARTNER ID',
    },
    company_id_label: {
        id: 'productinsights.company_id_label',
        defaultMessage: 'MNG COMPANY ID',
    },
    member_id_label: {
        id: 'productinsights.member_id_label',
        defaultMessage: 'Member ID',
    },
    company_recid_label: {
        id: 'productinsights.company_recid_label',
        defaultMessage: 'MNG REC ID',
    },
    partner_users_count: {
        id: 'productinsights.users_count',
        defaultMessage: 'USERS',
    },
    partner_clients_count: {
        id: 'productinsights.clients_count',
        defaultMessage: 'CLIENTS',
    },
    partner_instances_count: {
        id: 'productinsights.instances_count',
        defaultMessage: 'INSTANCES',
    },
    partner_name: {
        id: 'productinsights.partner_name',
        defaultMessage: 'NAME',
    },
    create: {
        id: 'productinsights.create',
        defaultMessage: 'Create',
    },
    map_features: {
        id: 'productinsights.map_features',
        defaultMessage: 'Map Features',
    },
    add_new_item: {
        id: 'productinsights.add_new_item',
        defaultMessage: 'Add New Item',
    },
    something_went_wrong: {
        id: 'productinsights.page_error',
        defaultMessage: 'Uh-oh. Something went wrong.',
    },
    contact_app_services: {
        id: 'productinsights.contact_app_services',
        defaultMessage: 'Please contact App Services.',
    },
    card_delete_products: {
        id: 'card_delete_products',
        defaultMessage: "At least one credit card must remain on-file for this partner because they have an active instance of a product that is billed through ConnectWise Home. If this partner still wants this card removed, they must add a new card in the ConnectWise Wallet before removing the card you are attempting to delete."
    },
    progress_step: {
        id: 'productinsights.progress_step',
        defaultMessage: 'Step {currentStep} of {totalSteps}',
    },
    yes: {
        id: 'productinsights.yes',
        defaultMessage: 'Yes',
    },
    no: {
        id: 'productinsights.no',
        defaultMessage: 'No',
    },
    confirm: {
        id: 'productinsights.confirm',
        defaultMessage: 'Confirm',
    },
    provision: {
        id: 'productinsights.provision',
        defaultMessage: 'Provision',
    },
    provision_product: {
        id: 'productinsights.provision_product',
        defaultMessage: 'Provision Product & Packages',
    },
    product_provisioned: {
        id: 'productinsights.product_provisioned',
        defaultMessage: 'Product Provisioned.',
    },
    provision_platform: {
        id: 'productinsights.provision_platform',
        defaultMessage: 'Provision Platform',
    },
    provision_platform_permission_error: {
        id: 'productinsights.provision_platform_permission_error',
        defaultMessage: 'Missing required permissions',
    },
    provision_good_bms: {
        id: 'productinsights.provision_good_bms',
        defaultMessage: 'Provision Platform Essentials',
    },
    show_x: {
        id: 'productinsights.show_x',
        defaultMessage: 'Show {x}',
    },
    provision_platform_contactDropDown_enterEmail: {
        id: 'productinsights.contactDropDown_EnterEmail',
        defaultMessage: 'Enter Email'
      },
      provision_good_bms_industryDropDown_enterIndustry: {
        id: 'productinsights.industryDropDown_EnterIndustry',
        defaultMessage: 'Enter Industry'
      },
      provision_good_bms_regionDropDown_enterRegion: {
        id: 'productinsights.regionDropDown_EnterRegion',
        defaultMessage: 'Enter Region'
      },
    enter_email: {
        id: 'enter_email',
        defaultMessage: 'Enter Email'
      },
    enter_product: {
        id: 'enter_product',
        defaultMessage: 'Enter Product'
      },
    enter_package: {
        id: 'enter_package',
        defaultMessage: 'Enter Package'
      },
    all_packages: {
        id: 'productinsights.all_packages',
        defaultMessage: 'All Packages'
      },
    filter_packages_title: {
        id: 'productinsights.filter_packages',
        defaultMessage: 'Filter Packages'
      },
    filter_entitlements_title: {
        id: 'productinsights.filter_entitlements',
        defaultMessage: 'Filter Entitlements'
      },
    billing: {
        id: 'productinsights.billing',
        defaultMessage: 'Billing'
      },
    all_entitlements: {
        id: 'productinsights.all_entitlements',
        defaultMessage: 'All'
      },
    filter_entitlements_title_by_restriction: {
        id: 'productinsights.filter_entitlements_title_by_restriction',
        defaultMessage: 'Assignable Restriction'
      },
    provision_platform_flyout_content: {
        id: 'productinsights.provisionPlatform_FlyoutContent',
        defaultMessage: 'Member Code can only consist of letters (a-z, A-Z), numbers (0-9) and hyphens ( - ). It cannot be empty or longer than 30 characters.'
    },
   
    client_detail_partner_id_label: {
        id: 'productinsights.clientDetail_partnerId_label',
        defaultMessage: 'Partner Id'
    },
    client_detail_product_label: {
        id: 'productinsights.clientDetail_product_label',
        defaultMessage: 'Product'
    },
    client_detail_client_id_label: {
        id: 'productinsights.clientDetail_clientId_label',
        defaultMessage: 'Client Id'
    },
    client_detail_redirect_uris_label: {
        id: 'productinsights.clientDetail_redirectUris_label',
        defaultMessage: 'Redirect URIs'
    },
    client_detail_usersWithAssignedAccess_label: {
        id: 'productinsights.clientDetail_usersWithAssignedAccess_label',
        defaultMessage: 'Users with Assigned Access'
    },
    client_detail_numberOfAssignedUsers_label: {
        id: 'productinsights.clientDetail_numberOfAssignedUsers_label',
        defaultMessage: 'Number of Assigned Users'
    },
    client_detail_remove: {
        id: 'productinsights.clientDetail_remove',
        defaultMessage: 'Remove'
    },
    client_detail_migrate: {
        id: 'productinsights.clientDetail_migrate',
        defaultMessage: 'Migrate Client'
    },
    client_detail_addRedirectUri: {
        id: 'productinsights.clientDetail_addRedirectUri',
        defaultMessage: 'Add Redirect URI'
    },
    client_detail_assignAdditionalUser: {
        id: 'productinsights.clientDetail_assignAdditionalUser',
        defaultMessage: 'Assign Additional User'
    },
    client_detail_assignUserDialog_userId: {
        id: 'productinsights.client_detail_assignUserDialog_userId',
        defaultMessage: 'User Id'
    },
    client_detail_assignUserDialog_email: {
        id: 'productinsights.client_detail_assignUserDialog_email',
        defaultMessage: 'Email'
    },
    client_detail_assignUserDialog_firstName: {
        id: 'productinsights.client_detail_assignUserDialog_firstName',
        defaultMessage: 'First Name'
    },
    client_detail_assignUserDialog_lastName: {
        id: 'productinsights.client_detail_assignUserDialog_lastName',
        defaultMessage: 'Last Name'
    },
    client_detail_assignUserDialog_noUserSelected: {
        id: 'productinsights.client_detail_assignUserDialog_noUserSelected',
        defaultMessage: 'No user selected !'
    },
    client_detail_assignUserDialog_assignUser: {
        id: 'productinsights.client_detail_assignUserDialog_assignUser',
        defaultMessage: 'Assign User'
    },
    client_detail_assignUserDialog_userAlreadyAssigned: {
        id: 'productinsights.client_detail_assignUserDialog_userAlreadyAssigned',
        defaultMessage: 'User already assigned !'
    },
    client_detail_assignUserDialog_userAssignedSuccessfully: {
        id: 'productinsights.client_detail_assignUserDialog_userAssignedSuccessfully',
        defaultMessage: 'User assigned successfully !'
    },
    client_detail_assignUserDialog_errorAssigningUser: {
        id: 'productinsights.client_detail_assignUserDialog_errorAssigningUser',
        defaultMessage: 'Error assigning user !'
    },
    client_detail_userRemovedSuccessfully: {
        id: 'productinsights.client_detail_userRemovedSuccessfully',
        defaultMessage: 'User removed successfully.'
    },
    client_detail_userRemovedFailed: {
        id: 'productinsights.client_detail_userRemovedFailed',
        defaultMessage: 'Failed to remove user.'
    },
    provisionactions: {
        id: 'productinsights.provisionactions',
        defaultMessage: 'Provision Actions',
    },
    auditlogs:{
        id: 'productinsights.auditlogs',
        defaultMessage: 'Audit Logs',
    },
    products_and_packages: {
        id: 'productinsights.products_and_packages',
        defaultMessage: 'Products & Packages',
    },
    packages_instances: {
        id: 'productinsights.packages_instances',
        defaultMessage: 'Package Instances',
    },
    packages: {
        id: 'productinsights.packages',
        defaultMessage: 'Packages',
    },
    package_provisioned: {
        id: 'productinsights.package_provisioned',
        defaultMessage: 'Package Provisioned.',
    },
    entitlements: {
        id: 'productinsights.entitlements',
        defaultMessage: 'Entitlements',
    },
    entitlement_management: {
        id: 'productinsights.entitlement_management',
        defaultMessage: 'Entitlement Management',
    },
    status: {
        id: 'productinsights.status',
        defaultMessage: 'Status',
    },
    retry: {
        id: 'productinsights.retry',
        defaultMessage: 'Retry',
    },
    package_provision_use_retry: {
        id: 'productinsights.package_provision_use_retry',
        defaultMessage:
            'The most recent provisioning attempt for this package failed. ' +
            'Go to the partner\'s Products and Packages tab, open Package Instances, and use the Retry button ' +
            'on that package instance instead of provisioning again.',
    },
    package_provision_in_progress: {
        id: 'productinsights.package_provision_in_progress',
        defaultMessage:
            'A provisioning attempt for this package is already in progress. ' +
            'Please wait for it to complete or use Retry from Package Instances if it has failed.',
    },
    go_to_package_instances: {
        id: 'productinsights.go_to_package_instances',
        defaultMessage: 'Go to Package Instances',
    },
    only_marketplace_products: {
        id: 'productinsights.only_marketplace_products',
        defaultMessage: 'Only Marketplace Products',
    },
    add_new_package: {
        id: 'productinsights.add_new_package',
        defaultMessage: 'Add New Package',
    },
    package_sku: {
        id: 'productinsights.package_sku',
        defaultMessage: 'SKU',
    },
    package_product_count: {
        id: 'productinsights.package_product_count',
        defaultMessage: 'Product Count',
    },
    package_is_allow_update: {
        id: 'productinsights.package_is_allow_update',
        defaultMessage: 'Allow Update',
    },
    package_version: {
        id: 'productinsights.package_version',
        defaultMessage: 'Version',
    },
    package_type: {
        id: 'productinsights.package_type',
        defaultMessage: 'Package Type',
    },
    pricing_and_packaging_category: {
        id: 'productinsights.pricing_and_packaging_category',
        defaultMessage: 'Pricing and Packaging Category',
    },
    show_package: {
        id: 'productinsights.show_package',
        defaultMessage: 'Show Package',
    },
     package_created_date : {
        id: 'productinsights.package_created_date',
        defaultMessage: 'Created date ',
    },
     package_updated_date : {
        id: 'productinsights.package_updated_date',
        defaultMessage: 'Updated Date',
    },
    description: {
        id: 'productinsights.description',
        defaultMessage: 'Description',
    },
    name: {
        id: 'productinsights.name',
        defaultMessage: 'Name',
    },
    package_licensed_partner: {
        id: 'productinsights.package_licensed_partner',
        defaultMessage: 'Licensed Partners',
    },
    package_included_products: {
        id: 'productinsights.package_included_products',
        defaultMessage: 'Included Products',
    },
    package_product_entitlement_search: {
        id: 'productinsights.package_product_entitlement_search',
        defaultMessage: 'Type at least three characters to search here for and add a product after selecting product type',
    },
    package_new_group: {
        id: 'productinsights.package_new_group',
        defaultMessage: 'To add new group please search here for products/entitlement',
    },
    package_package: {
        id: 'productinsights.package_package',
        defaultMessage: 'Package'
    },
    package_provisioning_groups: {
        id: 'productinsights.package_provisioning_groups',
        defaultMessage: 'Provisioning Groups',
    },
    package_id: {
        id: 'productinsights.package_id',
        defaultMessage: 'Package Id',
    },
    package_provisioned_count: {
        id: 'productinsights.package_provisioned_count',
        defaultMessage: 'Package Provisioned count',
    },
    package_provisioned_count_fetch_error: {
        id: 'productinsights.package_provisioned_count_fetch_error',
        defaultMessage: 'Error fetching Provisioned Partners Count for Packages.',
    },
    package_provisioned_count_unavailable: {
        id: 'productinsights.package_provisioned_count_unavailable',
        defaultMessage: '—',
    },
    package_delete_disabled_count_unavailable: {
        id: 'productinsights.package_delete_disabled_count_unavailable',
        defaultMessage:
            'Delete is unavailable until the provisioned partner count has loaded or the count could not be retrieved.',
    },
    provisioned_partners: {
        id: 'productinsights.provisioned_partners',
        defaultMessage: 'Provisioned Partners',
    },
    signup_json: {
        id: 'productinsights.signup_json',
        defaultMessage: 'Signup Json',
    },
    signup_form: {
        id: 'productinsights.signup_form',
        defaultMessage: 'Signup Form',
    },
    signup_template_saved: {
        id: 'productinsights.signup_template_saved',
        defaultMessage: 'Signup Template Saved',
    },
    signup_template_not_saved: {
        id: 'productinsights.signup_template_not_saved',
        defaultMessage: 'Signup Template Not Saved',
    },
    missing_permissions_msg: {
        id: 'productinsights.missing_permissions_msg',
        defaultMessage: 'Missing Required Permissions',
    },
    linkChildAccount: {
        id:'productinsights.link_Child_account',
        defaultMessage: 'Link to Child Account',
    },
    linkProviderAccount: {
        id:'productinsights.link_Provider_account',
        defaultMessage: 'Link to Service Provider',
    },
    ownedBy: {
        id: 'productinsights.relationship_type_owned_by',
        defaultMessage: 'Owned By'
    },
    noChildAccount: {
        id: 'productinsights.no_child_account_linked',
        defaultMessage: 'No Child Account Linked'
    },
    noParentAccount: {
        id: 'productinsights.no_parent_account_linked',
        defaultMessage: 'No Parent Account Linked'
    },
    unlink_from_partner_warning:{
        id: 'productinsights.unlink_from_partner_warning',
        defaultMessage: 'Are you sure you want to de-link the mapping? Doing this would disrupt the access controls on the Franchise account'
    },
    view_all_product_entitlement_management: {
        id: 'productinsights.view_all_product_entitlement_management',
        defaultMessage: 'View All Products'
    },
    download_all_product_entitlement_management: {
        id: 'productinsights.download_all_product_entitlement_management',
        defaultMessage: 'Download All Products'
    },
    view_all_feature_entitlement_management: {
        id: 'productinsights.view_all_feature_entitlement_management',
        defaultMessage: 'View All Features'
    },
    download_all_feature_entitlement_management: {
        id: 'productinsights.download_all_feature_entitlement_management',
        defaultMessage: 'Download All Features'
    },
    create_product_entitlement_name_hint_msg: {
        id: 'create_product_entitlement_name_hint_msg',
        defaultMessage:
            'The product name should have specific format. The format will be "ConnectWise_actual product name_any alphabetical characters". Example : ConnectWise_RMM_Platform Essentials',
    },
    create_product_entitlement_sku_hint_msg: {
        id: 'create_product_entitlement_sku_hint_msg',
        defaultMessage:
            'User can mention the SKU of the product created. Example : CW_VULNERABILITYMGNT',
    },
    create_feature_entitlement_name_hint_msg: {
        id: 'create_feature_entitlement_name_hint_msg',
        defaultMessage:
            'The feature name should have specific format. The format will be DOMAIN-NAME_Feature-Name. Example: ALERTING_Feature-Name',
    },
    create_feature_entitlement_sku_hint_msg: {
        id: 'create_feature_entitlement_sku_hint_msg',
        defaultMessage:
            'User can mention the SKU of the feature created. Example : CW_VULNERABILITYMGNT',
    },
    copy_product_entitlement_name_hint_msg: {
        id: 'copy_product_entitlement_name_hint_msg',
        defaultMessage:
            'The copied product must have a unique name separate from the product it was copied from. This form adds "_copy" to the end by default, but you are free to change it.',
    },
    copy_product_entitlement_sku_hint_msg: {
        id: 'copy_product_entitlement_sku_hint_msg',
        defaultMessage:
            'Even though the product is being copied, the SKU for the copy must be unique. This form sets the SKU to blank for the copy, but you can edit it after the copy action.',
    },
    create_copy_in_other_region: {
        id: 'productinsights.create_copy_in_other_region',
        defaultMessage: 'Create copy in other region',
    },
    copy_product_to_regions_title: {
        id: 'productinsights.copy_product_to_regions_title',
        defaultMessage: 'Copy Product to Other Region(s)',
    },
    copy_product_to_regions_description: {
        id: 'productinsights.copy_product_to_regions_description',
        defaultMessage:
            'Select the target region(s) to copy {productName} into. The source region is pre-selected and cannot be changed.',
    },
    copy_product_to_regions_source_label: {
        id: 'productinsights.copy_product_to_regions_source_label',
        defaultMessage: ' (source — already exists)',
    },
    copy_product_to_regions_loading: {
        id: 'productinsights.copy_product_to_regions_loading',
        defaultMessage: 'Copying product to selected region(s), please wait…',
    },
    copy_product_to_regions_unexpected_error: {
        id: 'productinsights.copy_product_to_regions_unexpected_error',
        defaultMessage: 'The copy operation failed unexpectedly. Please try again.',
    },
    copy_product_to_regions_network_error: {
        id: 'productinsights.copy_product_to_regions_network_error',
        defaultMessage: 'A network error occurred. Please check your connection and try again.',
    },
    copy_product_to_regions_skipped_prefix: {
        id: 'productinsights.copy_product_to_regions_skipped_prefix',
        defaultMessage: 'Skipped: ',
    },
    copy_product_to_regions_failed_prefix: {
        id: 'productinsights.copy_product_to_regions_failed_prefix',
        defaultMessage: 'Product creation failed: ',
    },
    copy_product_to_regions_new_product: {
        id: 'productinsights.copy_product_to_regions_new_product',
        defaultMessage: 'New product: {productName} (ID: {productId})',
    },
    copy_product_to_regions_features_mapped: {
        id: 'productinsights.copy_product_to_regions_features_mapped',
        defaultMessage: '{mapped}/{total} features mapped successfully.',
    },
    copy_product_to_regions_partial_hint: {
        id: 'productinsights.copy_product_to_regions_partial_hint',
        defaultMessage: ' Check the logs for unmapped features.',
    },
    copy_product_to_regions_download_transaction_log: {
        id: 'productinsights.copy_product_to_regions_download_transaction_log',
        defaultMessage: 'Download Transaction Log',
    },
    copy_product_to_regions_download_failed_records: {
        id: 'productinsights.copy_product_to_regions_download_failed_records',
        defaultMessage: 'Download Failed Records',
    },
    copy_product_to_regions_copy_button: {
        id: 'productinsights.copy_product_to_regions_copy_button',
        defaultMessage: 'Copy Product',
    },
    search_all_product_entitlement_management: {
        id: 'productinsights.search_all_product_entitlement_management',
        defaultMessage: 'Search Product'
    },
    search_all_feature_entitlement_management: {
        id: 'productinsights.search_all_feature_entitlement_management',
        defaultMessage: 'Search Feature'
    },
    update: {
        id: 'productinsights.update',
        defaultMessage: 'Update',
    },
    product_entitlement_delete_warning: {
        id: 'productinsights.product_entitlement_delete_warning',
        defaultMessage: 'Are you sure you no longer want "{productName} product?"',
    },
    product_entitlement_delete_success: {
        id: 'productinsights.product_entitlement_delete_success',
        defaultMessage: '{productName} product deleted successfully',
    },
    product_entitlement_delete_failed: {
        id: 'productinsights.product_entitlement_delete_failed',
        defaultMessage: 'Failed to delete {productName} product',
    },
    delete_selected_entitlements: {
        id: 'productinsights.delete_selected_entitlements',
        defaultMessage: 'Delete Selected Entitlements',
    },
    product_entitlements: {
        id: 'productinsights.product_entitlements',
        defaultMessage: 'Product Entitlements',
    },
     no_entitlements: {
        id: 'productinsights.no_entitlements',
        defaultMessage: 'No Product Entitlements configured in the package',
    },
    package_dependencies: {
        id: 'productinsights.package_dependencies',
        defaultMessage: 'Package Dependency Rules',
    },
    package_relation_eligibility: {
        id: 'productinsights.package_relation_eligibility',
        defaultMessage: 'Eligibility',
    },
    package_relation_restriction: {
        id: 'productinsights.package_relation_restriction',
        defaultMessage: 'Restriction',
    },
    add_to_eligibility: {
        id: 'productinsights.add_to_eligibility',
        defaultMessage: 'Add to Eligibility',
    },
    add_to_restriction: {
        id: 'productinsights.add_to_restriction',
        defaultMessage: 'Add to Restriction',
    },
    noPackageRelationshipMappingAdded: {
        id: 'productinsights.no_package_relationship_mapping_added',
        defaultMessage: 'No dependency rules configured',
    },
    search_package_placeholder: {
        id: 'productinsights.search_package_placeholder',
        defaultMessage: 'Start typing to find a package...',
    },
     noPackageConfigurationAdded: {
        id: 'productinsights.no_package_configuration_added',
        defaultMessage: 'No Package Configuration Added',
    },
    jira_reference_flyout_content: {
        id: 'productinsights.JiraReference_FlyoutContent',
        defaultMessage: 'Please input PIR Jira number, example PIR-1234.'
    },
    access_request_title: {
        id: 'productinsights.access_request_title',
        defaultMessage: 'Access Request Details',
    },
    access_request_subtitle: {
        id: 'productinsights.access_request_subtitle',
        defaultMessage: 'Provide required details to gain access to platform',
    },
    access_request_reason_label: {
        id: 'productinsights.access_request_reason_label',
        defaultMessage: 'Reason for Access',
    },
    access_request_other_reason_label: {
        id: 'productinsights.access_request_other_reason_label',
        defaultMessage: 'Other',
    },
    access_request_other_reason_placeholder: {
        id: 'productinsights.access_request_other_reason_placeholder',
        defaultMessage: 'Enter text',
    },
    access_request_reason_placeholder: {
        id: 'productinsights.access_request_reason_placeholder',
        defaultMessage: 'Reason to login',
    },
    access_request_reason_troubleshoot_partner_issue: {
        id: 'productinsights.access_request_reason_troubleshoot_partner_issue',
        defaultMessage: 'Troubleshoot a partner-reported issue (general support)',
    },
    access_request_reason_reproduce_suspected_defect: {
        id: 'productinsights.access_request_reason_reproduce_suspected_defect',
        defaultMessage: 'Reproduce or confirm a suspected defect',
    },
    access_request_reason_validate_configuration_behavior: {
        id: 'productinsights.access_request_reason_validate_configuration_behavior',
        defaultMessage:
            'Validate configuration, policy, workflow, task, report, or user-permission behavior',
    },
    access_request_reason_verify_psa_integration_sync: {
        id: 'productinsights.access_request_reason_verify_psa_integration_sync',
        defaultMessage: 'Verify PSA or other integration synchronization',
    },
    access_request_reason_collect_diagnostic_data: {
        id: 'productinsights.access_request_reason_collect_diagnostic_data',
        defaultMessage: 'Collect logs, HAR files, or diagnostic data',
    },
    access_request_reason_verify_fix_or_hotfix: {
        id: 'productinsights.access_request_reason_verify_fix_or_hotfix',
        defaultMessage: 'Verify a fix or hotfix for a confirmed defect',
    },
    access_request_reason_investigate_partner_incident: {
        id: 'productinsights.access_request_reason_investigate_partner_incident',
        defaultMessage: 'Investigate an incident affecting one or more partners',
    },
    access_request_reason_others: {
        id: 'productinsights.access_request_reason_others',
        defaultMessage: 'Others',
    },
    access_request_issue_type_salesforce: {
        id: 'productinsights.access_request_issue_type_salesforce',
        defaultMessage: 'Salesforce',
    },
    access_request_issue_type_jira_ticket: {
        id: 'productinsights.access_request_issue_type_jira_ticket',
        defaultMessage: 'Jira Ticket',
    },
    access_request_issue_type_label: {
        id: 'productinsights.access_request_issue_type_label',
        defaultMessage: 'Ticket System',
    },
    access_request_issue_type_placeholder: {
        id: 'productinsights.access_request_issue_type_placeholder',
        defaultMessage: 'Select Issue Type',
    },
    access_request_ticket_label: {
        id: 'productinsights.access_request_ticket_label',
        defaultMessage: 'Ticket / Case ID',
    },
    access_request_case_id_placeholder: {
        id: 'productinsights.access_request_case_id_placeholder',
        defaultMessage: 'Case ID',
    },
    access_request_ticket_id_placeholder: {
        id: 'productinsights.access_request_ticket_id_placeholder',
        defaultMessage: 'Ticket ID',
    },
    confirm_launch_request: {
        id: 'productinsights.confirm_launch_request',
        defaultMessage: 'Confirm Launch Request',
    },
    launch_into_partner_account: {
        id: 'productinsights.launch_into_partner_account',
        defaultMessage: 'Launch into Platform',
    },
    product_support_account_label: {
        id: 'productinsights.product_support_account_label',
        defaultMessage: 'Product Support Account',
    },
    access_request_launch_success: {
        id: 'productinsights.access_request_launch_success',
        defaultMessage: 'Access request recorded successfully. Platform launch will be available once ticket validation is enabled.',
    },
    product_support_account_disabled_tooltip: {
        id: 'productinsights.product_support_account_disabled_tooltip',
        defaultMessage: 'Product Support Account is disabled by the partner.',
    },
    platform_launch_audit_failed: {
        id: 'productinsights.platform_launch_audit_failed',
        defaultMessage: 'Failed to record platform launch access request.',
    },
    platform_launch_access_denied_title: {
        id: 'productinsights.platform_launch_access_denied_title',
        defaultMessage: 'Access Denied!!',
    },
    platform_launch_access_denied_message: {
        id: 'productinsights.platform_launch_access_denied_message',
        defaultMessage: 'The partner has disabled support access for your environment.',
    },
    platform_launch_request_support_access: {
        id: 'productinsights.platform_launch_request_support_access',
        defaultMessage: 'Request Product Support Access',
    },
    platform_launch_request_pending_title: {
        id: 'productinsights.platform_launch_request_pending_title',
        defaultMessage: 'Access request pending!',
    },
    platform_launch_request_pending_message: {
        id: 'productinsights.platform_launch_request_pending_message',
        defaultMessage:
            'Request to grant access for product support has been sent to partner, wait for partner to grant access!',
    },
    platform_launch_request_sent_title: {
        id: 'productinsights.platform_launch_request_sent_title',
        defaultMessage: 'Access request has been sent to the partner!',
    },
    platform_launch_request_sent_message: {
        id: 'productinsights.platform_launch_request_sent_message',
        defaultMessage: 'Notification for request to grant access has been sent to partner.',
    },
    platform_launch_request_sent_message_preview: {
        id: 'productinsights.platform_launch_request_sent_message_preview',
        defaultMessage:
            'Preview only: no request was sent to the partner. This simulates the success state until the support-access API is available.',
    },
    platform_launch_request_pending_message_preview: {
        id: 'productinsights.platform_launch_request_pending_message_preview',
        defaultMessage:
            'Preview only: launch stays disabled while this simulated pending state is shown. Status is stored for this browser session until the support-access API is available.',
    },
    platform_launch_support_access_preview_notice: {
        id: 'productinsights.platform_launch_support_access_preview_notice',
        defaultMessage:
            'Preview: user list and submit are simulated until the partner notify-user API is integrated. No email or partner notification is sent.',
    },
    platform_launch_preview_notify_user_1: {
        id: 'productinsights.platform_launch_preview_notify_user_1',
        defaultMessage: 'Sample notify user (preview)',
    },
    platform_launch_preview_notify_user_2: {
        id: 'productinsights.platform_launch_preview_notify_user_2',
        defaultMessage: 'Second sample user (preview)',
    },
    platform_launch_support_request_failed: {
        id: 'productinsights.platform_launch_support_request_failed',
        defaultMessage: 'Could not submit the support access request. Please try again.',
    },
    platform_launch_select_user_title: {
        id: 'productinsights.platform_launch_select_user_title',
        defaultMessage: 'Select User',
    },
    platform_launch_select_user_subtitle: {
        id: 'productinsights.platform_launch_select_user_subtitle',
        defaultMessage:
            'Select a partner user to notify them about the access required for this task or support action.',
    },
    platform_launch_select_user_label: {
        id: 'productinsights.platform_launch_select_user_label',
        defaultMessage: 'Select User',
    },
    platform_launch_select_user_placeholder: {
        id: 'productinsights.platform_launch_select_user_placeholder',
        defaultMessage: 'Select User',
    },
    platform_launch_request_access: {
        id: 'productinsights.platform_launch_request_access',
        defaultMessage: 'Request Access',
    },
    access_request_ticket_error_invalid: {
        id: 'productinsights.access_request_ticket_error_invalid',
        defaultMessage: 'Enter a valid ticket or case ID before confirming launch.',
    },
    access_request_ticket_error_partner_not_associated: {
        id: 'productinsights.access_request_ticket_error_partner_not_associated',
        defaultMessage:
            'Salesforce Ticket Id cannot be validated as partner Id is not associated with the entered ticket Id.',
    },
    access_request_ticket_error_case_closed: {
        id: 'productinsights.access_request_ticket_error_case_closed',
        defaultMessage: 'Salesforce Ticket id for salesforce is valid but case is already closed.',
    },
    access_request_ticket_warning_jira_closed: {
        id: 'productinsights.access_request_ticket_warning_jira_closed',
        defaultMessage:
            'Jira Ticket id is validated but ticket is already closed. You can still debug your case and verify!',
    },
    create_sso_account: {
        id: 'productinsights.create_sso_account',
        defaultMessage: 'Create Company',
    },
    sso_sf_account_id_label: {
        id: 'productinsights.sso_sf_account_id_label',
        defaultMessage: 'Salesforce Account ID',
    },
    sso_validate_sf_guid: {
        id: 'productinsights.sso_validate_sf_guid',
        defaultMessage: 'Validate & Fetch',
    },
    sso_validate_sf_guid_info: {
        id: 'productinsights.sso_validate_sf_guid_info',
        defaultMessage:
            'Validates the Salesforce Account ID and its association with an existing SSO Partner ID. Upon successful validation, it retrieves the contact details from Salesforce.',
    },
    sso_sf_guid_invalid: {
        id: 'productinsights.sso_sf_guid_invalid',
        defaultMessage: 'Invalid Salesforce Account ID',
    },
    sso_sf_account_id_required: {
        id: 'productinsights.sso_sf_account_id_required',
        defaultMessage: 'Please enter valid Salesforce Account ID',
    },
    sso_contact_email_label: {
        id: 'productinsights.sso_contact_email_label',
        defaultMessage: 'Salesforce Contact Email',
    },
    sso_fetch_user_select_contact_email: {
        id: 'productinsights.sso_fetch_user_select_contact_email',
        defaultMessage: 'Please select the Salesforce contact email address.',
    },
    sso_contact_email_placeholder: {
        id: 'productinsights.sso_contact_email_placeholder',
        defaultMessage: 'Search or select email…',
    },
    Request_For_Deletion: {
        id: 'productinsights.Request_For_Deletion',
        defaultMessage: 'Request for Deletion',
    },
    request_for_deletion_dialog_intro: {
        id: 'productinsights.request_for_deletion_dialog_intro',
        defaultMessage:
            'Provide a reason for requesting deletion. The instance status will be set to Termination Planned when you continue.',
    },
    request_for_deletion_reason_label: {
        id: 'productinsights.request_for_deletion_reason_label',
        defaultMessage: 'Reason for deletion',
    },
    request_for_deletion_reason_aria: {
        id: 'productinsights.request_for_deletion_reason_aria',
        defaultMessage: 'Reason for deletion, required',
    },
    request_for_deletion_submit: {
        id: 'productinsights.request_for_deletion_submit',
        defaultMessage: 'Submit',
    },
    request_for_deletion_reason_invalid: {
        id: 'productinsights.request_for_deletion_reason_invalid',
        defaultMessage:
            'Please enter a reason that includes at least one letter. Numbers and special characters are allowed.',
    },
    Unlock_Platform_Instance: {
        id: 'productinsights.Unlock_Platform_Instance',
        defaultMessage: 'Unlock Platform Instance',
    },
    unlock_platform_instance_dialog_intro: {
        id: 'productinsights.unlock_platform_instance_dialog_intro',
        defaultMessage:
            'Provide a reason for reactivating this platform instance. The instance status will return to Active and the request-for-deletion note will be cleared when you continue.',
    },
    unlock_platform_instance_reason_label: {
        id: 'productinsights.unlock_platform_instance_reason_label',
        defaultMessage: 'Reason for unlock',
    },
    unlock_platform_instance_reason_aria: {
        id: 'productinsights.unlock_platform_instance_reason_aria',
        defaultMessage: 'Reason for unlock, required',
    },
    unlock_platform_instance_submit: {
        id: 'productinsights.unlock_platform_instance_submit',
        defaultMessage: 'Submit',
    },
    unlock_platform_instance_reason_invalid: {
        id: 'productinsights.unlock_platform_instance_reason_invalid',
        defaultMessage:
            'Please enter a reason that includes at least one letter. Numbers and special characters are allowed.',
    },
    platform_request_for_deletion_saved_note: {
        id: 'productinsights.platform_request_for_deletion_saved_note',
        defaultMessage: 'Request for deletion (saved reason)',
    },
    unlock_platform_instance_saved_note: {
        id: 'productinsights.unlock_platform_instance_saved_note',
        defaultMessage: 'Unlock platform instance (saved reason)',
    },
    brightgauge_datasource_update_dialog_intro: {
        id: 'productinsights.brightgauge_datasource_update_dialog_intro',
        defaultMessage:
            'Provide notes and the Salesforce Opportunity ID for <emphasis>additional datasource quantity</emphasis> update before saving.',
    },
    brightgauge_support_free_datasource_notes_dialog_intro: {
        id: 'productinsights.brightgauge_support_free_datasource_notes_dialog_intro',
        defaultMessage:
            'Provide notes for <emphasis>support free datasource quantity</emphasis> update before saving.',
    },
    brightgauge_datasource_opportunity_id_label: {
        id: 'productinsights.brightgauge_datasource_opportunity_id_label',
        defaultMessage: 'Salesforce Opportunity ID',
    },
    brightgauge_datasource_opportunity_id_required: {
        id: 'productinsights.brightgauge_datasource_opportunity_id_required',
        defaultMessage: 'Salesforce Opportunity ID is required.',
    },
    brightgauge_datasource_notes_label: {
        id: 'productinsights.brightgauge_datasource_notes_label',
        defaultMessage: 'Notes',
    },
    brightgauge_datasource_notes_required: {
        id: 'productinsights.brightgauge_datasource_notes_required',
        defaultMessage: 'Notes are required.',
    },
    brightgauge_datasource_notes_invalid: {
        id: 'productinsights.brightgauge_datasource_notes_invalid',
        defaultMessage:
            'Please enter notes that include at least one letter. Numbers and special characters are allowed.',
    },
    brightgauge_datasource_update_submit: {
        id: 'productinsights.brightgauge_datasource_update_submit',
        defaultMessage: 'Save',
    },
    brightgauge_not_in_partner_provisioned_package: {
        id: 'productinsights.brightgauge_not_in_partner_provisioned_package',
        defaultMessage: 'The BrightGauge product is not part of any provisioned package configuration.',
    },
    brightgauge_additional_datasource_contract_quantity_label: {
        id: 'productinsights.brightgauge_additional_datasource_contract_quantity_label',
        defaultMessage: 'Additional Datasource Contract Quantity',
    },
    brightgauge_support_free_datasource_quantity_label: {
        id: 'productinsights.brightgauge_support_free_datasource_quantity_label',
        defaultMessage: 'Support Free Datasource Quantity',
    },
    brightgauge_swo_contract_confirm_message: {
        id: 'productinsights.brightgauge_swo_contract_confirm_message',
        defaultMessage: 'Is partner on the SwO contract?',
    },
    swap_package: {
        id: 'productinsights.swap_package',
        defaultMessage: 'Swap',
    },
    upgrade_package: {
        id: 'productinsights.upgrade_package',
        defaultMessage: 'Upgrade',
    },
    downgrade_package: {
        id: 'productinsights.downgrade_package',
        defaultMessage: 'Downgrade',
    },
    downgrade_coming_soon: {
        id: 'productinsights.downgrade_coming_soon',
        defaultMessage: 'Coming soon',
    },
    select_upgrade_package: {
        id: 'productinsights.select_upgrade_package',
        defaultMessage: 'Select Upgrade Package',
    },
    package_offering_preview: {
        id: 'productinsights.package_offering_preview',
        defaultMessage: 'Package Offering Preview',
    },
    products_to_add: {
        id: 'productinsights.products_to_add',
        defaultMessage: 'Products to be Added',
    },
    entitlements_to_add: {
        id: 'productinsights.entitlements_to_add',
        defaultMessage: 'Entitlements to be Added',
    },
    entitlements_to_remove: {
        id: 'productinsights.entitlements_to_remove',
        defaultMessage: 'Entitlements to be Removed',
    },
    unchanged_products: {
        id: 'productinsights.unchanged_products',
        defaultMessage: 'Unchanged Products',
    },
    unchanged_entitlements: {
        id: 'productinsights.unchanged_entitlements',
        defaultMessage: 'Unchanged Entitlements',
    },
    confirm_upgrade: {
        id: 'productinsights.confirm_upgrade',
        defaultMessage: 'Confirm Upgrade',
    },
    confirm_upgrade_message: {
        id: 'productinsights.confirm_upgrade_message',
        defaultMessage: 'Are you sure you want to upgrade from "{sourcePackage}" to "{targetPackage}"? This action will add new products and entitlements, and remove superseded entitlements.',
    },
    no_eligible_upgrades: {
        id: 'productinsights.no_eligible_upgrades',
        defaultMessage: 'No eligible upgrade packages available for this package instance.',
    },
    package_provisioning_eligibility: {
        id: 'productinsights.package_provisioning_eligibility',
        defaultMessage: 'Package provisioning eligibility:',
    },
    failed_to_validate_package_eligibility: {
        id: 'productinsights.failed_to_validate_package_eligibility',
        defaultMessage: 'Failed to validate package eligibility',
    },
    package_cannot_be_provisioned_errors: {
        id: 'productinsights.package_cannot_be_provisioned_errors',
        defaultMessage: 'The package cannot be provisioned because of the errors below:',
    },
    eligible: {
        id: 'productinsights.eligible',
        defaultMessage: 'Eligible',
    },
    ineligible: {
        id: 'productinsights.ineligible',
        defaultMessage: 'Ineligible',
    },
    next: {
        id: 'productinsights.next',
        defaultMessage: 'Next',
    },
    back: {
        id: 'productinsights.back',
        defaultMessage: 'Back',
    },
    no_changes: {
        id: 'productinsights.no_changes',
        defaultMessage: 'No changes',
    },
    source_package_label: {
        id: 'productinsights.source_package_label',
        defaultMessage: 'Source Package:',
    },
    target_package_label: {
        id: 'productinsights.target_package_label',
        defaultMessage: 'Target Package:',
    },
    signup_data_step_title: {
        id: 'productinsights.signup_data_step_title',
        defaultMessage: 'Product Signup Data',
    },
    signup_data_step_description: {
        id: 'productinsights.signup_data_step_description',
        defaultMessage: 'The target package contains new products that require provisioning. Please fill in the signup data below.',
    },
    no_signup_fields: {
        id: 'productinsights.no_signup_fields',
        defaultMessage: 'No signup fields required for this product.',
    },
    import_package_button: {
        id: 'productinsights.import_package_button',
        defaultMessage: 'Import Package',
    },
    import_package_title: {
        id: 'productinsights.import_package_title',
        defaultMessage: 'Import Package Configuration',
    },
    import_package_note: {
        id: 'productinsights.import_package_note',
        defaultMessage:
            'Upload a package JSON export. Confirm will create or update the package in this environment. The package details will be searched by name, hence keep case sensitivity in mind.',
    },
    import_package_upload_json: {
        id: 'productinsights.import_package_upload_json',
        defaultMessage: 'Upload JSON',
    },
    import_package_confirm: {
        id: 'productinsights.import_package_confirm',
        defaultMessage: 'Confirm Import',
    },
    import_package_close: {
        id: 'productinsights.import_package_close',
        defaultMessage: 'Close',
    },
    import_package_invalid_json_file: {
        id: 'productinsights.import_package_invalid_json_file',
        defaultMessage: 'Please upload a valid JSON file',
    },
    import_package_invalid_json_content: {
        id: 'productinsights.import_package_invalid_json_content',
        defaultMessage: 'Invalid JSON file. Please upload a valid package export.',
    },
    import_package_preview_name: {
        id: 'productinsights.import_package_preview_name',
        defaultMessage: 'Name:',
    },
    import_package_preview_action: {
        id: 'productinsights.import_package_preview_action',
        defaultMessage: 'Action:',
    },
    import_package_preview_products: {
        id: 'productinsights.import_package_preview_products',
        defaultMessage: 'Products:',
    },
    import_package_preview_entitlements: {
        id: 'productinsights.import_package_preview_entitlements',
        defaultMessage: 'Entitlements:',
    },
    import_package_preview_upgrades: {
        id: 'productinsights.import_package_preview_upgrades',
        defaultMessage: 'Upgrades/Downgrades:',
    },
    import_package_preview_relationships: {
        id: 'productinsights.import_package_preview_relationships',
        defaultMessage: 'Relationships:',
    },
    import_package_validation_errors: {
        id: 'productinsights.import_package_validation_errors',
        defaultMessage: 'Validation errors',
    },
    import_package_step_header: {
        id: 'productinsights.import_package_step_header',
        defaultMessage: 'Step',
    },
    import_package_name_header: {
        id: 'productinsights.import_package_name_header',
        defaultMessage: 'Name',
    },
    import_package_status_header: {
        id: 'productinsights.import_package_status_header',
        defaultMessage: 'Status',
    },
    import_package_message_header: {
        id: 'productinsights.import_package_message_header',
        defaultMessage: 'Message',
    },
    import_package_download_failed_records: {
        id: 'productinsights.import_package_download_failed_records',
        defaultMessage: 'Download Failed Records',
    },
    import_package_download_transaction_logs: {
        id: 'productinsights.import_package_download_transaction_logs',
        defaultMessage: 'Download Transaction Logs',
    },
    import_package_please_wait: {
        id: 'productinsights.import_package_please_wait',
        defaultMessage: 'Please wait, this action will take some time.',
    },
    import_package_validation_passed: {
        id: 'productinsights.import_package_validation_passed',
        defaultMessage: 'Validation passed. Ready to import package.',
    },
    import_package_success: {
        id: 'productinsights.import_package_success',
        defaultMessage: 'Package imported successfully.',
    },
    import_package_completed_with_errors: {
        id: 'productinsights.import_package_completed_with_errors',
        defaultMessage: 'Package import completed with errors. Review step logs. For Create failures, check whether compensating cleanup ran or if manual package deletion is required before re-import.',
    },
    import_package_failed: {
        id: 'productinsights.import_package_failed',
        defaultMessage: 'Failed to import package.',
    },
    import_package_validate_failed: {
        id: 'productinsights.import_package_validate_failed',
        defaultMessage: 'Failed to validate package import.',
    },
    export_package_failed: {
        id: 'productinsights.export_package_failed',
        defaultMessage: 'Failed to export package configuration.',
    },
    export_package_download_title: {
        id: 'productinsights.export_package_download_title',
        defaultMessage: 'Download package configuration',
    },
    cd_key: {
        id: 'productinsights.cd_key',
        defaultMessage: 'CD Key',
    },
    last_pulsed: {
        id: 'productinsights.last_pulsed',
        defaultMessage: 'Last Pulsed',
    },
    billing_type: {
        id: 'productinsights.billing_type',
        defaultMessage: 'Billing Type',
    },
    license_type: {
        id: 'productinsights.license_type',
        defaultMessage: 'License Type',
    },
    not_available: {
        id: 'productinsights.not_available',
        defaultMessage: 'Not Available',
    },
    install_type: {
        id: 'productinsights.install_type',
        defaultMessage: 'Install Type',
    },
});
 
export default Locale;